export const practiceLeadPlans: Record<string, { practice: string; bullets: string[] }> = {
  "personal-injury-lawyer-seo": {
    "practice": "personal injury",
    "bullets": [
      "Where you rank for car accident, truck and wrongful death searches in your city",
      "Your Google Business Profile and map results across your service area",
      "Which case types competitors win that you're missing",
      "The three fixes most likely to bring more signed cases in the next 90 days"
    ]
  },
  "bankruptcy-lawyer-seo": {
    "practice": "bankruptcy",
    "bullets": [
      "Where you rank for Chapter 7, Chapter 13 and debt relief searches",
      "Your Google Business Profile and map results in your market",
      "Gaps against the firms holding the local map pack",
      "The three fixes most likely to bring more consultations in the next 90 days"
    ]
  },
  "family-law-lawyer-seo": {
    "practice": "family law",
    "bullets": [
      "Where you rank for divorce, custody and support searches in each county you serve",
      "Your Google Business Profile for every office",
      "Missing pages for the matters and counties you handle",
      "The three fixes most likely to bring more consultations in the next 90 days"
    ]
  },
  "corporate-business-lawyer-seo": {
    "practice": "business law",
    "bullets": [
      "Where you rank for the matters you want: formation, contracts, M&A and litigation",
      "How your attorney profiles and practice pages compare with competing firms",
      "Sector and matter searches you could win",
      "The three fixes most likely to bring more new matters in the next 90 days"
    ]
  },
  "immigration-lawyer-seo": {
    "practice": "immigration",
    "bullets": [
      "Where you rank for visa, green card and deportation searches",
      "Your Spanish-language and other language visibility",
      "Your Google Business Profile and map results in your market",
      "The three fixes most likely to bring more consultations in the next 90 days"
    ]
  },
  "dui-dwi-lawyer-seo": {
    "practice": "DUI",
    "bullets": [
      "Where you rank for DUI and DWI searches in each county you defend in",
      "Your Google Business Profile and after-hours call setup",
      "Mugshot and arrest-record sites ranking for your name",
      "The three fixes most likely to bring more calls in the next 90 days"
    ]
  },
  "employment-law-lawyer-seo": {
    "practice": "employment law",
    "bullets": [
      "Where you rank for wrongful termination, discrimination and wage searches",
      "Whether your pages speak clearly to employees or employers",
      "Your Google Business Profile and map results in your market",
      "The three fixes most likely to bring more consultations in the next 90 days"
    ]
  },
  "medical-malpractice-lawyer-seo": {
    "practice": "medical malpractice",
    "bullets": [
      "Where you rank for birth injury, surgical error and misdiagnosis searches",
      "How your content shows accuracy and attorney review",
      "Injury-type and state searches you could win",
      "The three fixes most likely to bring more qualified cases in the next 90 days"
    ]
  },
  "workers-compensation-lawyer-seo": {
    "practice": "workers' comp",
    "bullets": [
      "Where you rank for workers' comp and denied-claim searches in your city",
      "Your Google Business Profile and map pack position",
      "Industry and Spanish-language searches you're missing",
      "The three fixes most likely to bring more cases in the next 90 days"
    ]
  },
  "real-estate-law-lawyer-seo": {
    "practice": "real estate law",
    "bullets": [
      "Where you rank for closing, landlord-tenant and investor searches",
      "Your Google Business Profile and map results in your market",
      "Pages agents and lenders see when they look you up",
      "The three fixes most likely to bring more matters in the next 90 days"
    ]
  },
  "tax-law-lawyer-seo": {
    "practice": "tax law",
    "bullets": [
      "Where you rank for IRS audit, tax debt and offer in compromise searches",
      "How your credentials show against tax-resolution companies",
      "Problem-specific searches you could win",
      "The three fixes most likely to bring more tax controversy clients in the next 90 days"
    ]
  },
  "criminal-defense-lawyer-seo": {
    "practice": "criminal defense",
    "bullets": [
      "Where you rank for charge and county searches you defend",
      "Your Google Business Profile and after-hours call setup",
      "Charge types and courts competitors win that you're missing",
      "The three fixes most likely to bring more calls in the next 90 days"
    ]
  },
  "estate-planning-lawyer-seo": {
    "practice": "estate planning",
    "bullets": [
      "Where you rank for wills, trusts and probate searches in your area",
      "Your Google Business Profile and map results",
      "Planning and probate searches you could win",
      "The three fixes most likely to bring more consultations in the next 90 days"
    ]
  }
};
